const testModes = new Set(['mobile-development', 'mobile-staging']);

export function parseSessionTestLimit(mode, raw) {
    if (raw === undefined || raw === null || raw === '') return null;
    if (!testModes.has(mode)) throw new Error('Native session test limits are forbidden in this build mode.');
    const seconds = Number(raw);
    if (!Number.isInteger(seconds) || seconds < 1 || seconds > 300) {
        throw new Error('Native session test limit must be an integer from 1 to 300 seconds.');
    }
    return seconds;
}

export function limitNativeSessionExpiry(expiry, mode, raw, now = Date.now()) {
    // A normal website or production bundle must never activate this test mode.
    if (!testModes.has(mode)) return expiry;
    const seconds = parseSessionTestLimit(mode, raw);
    return seconds === null ? expiry : Math.min(expiry, now + seconds * 1000);
}
